(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('ChamadosPorFila', ChamadosPorFila);

    ChamadosPorFila.$inject = ['$resource'];

    function ChamadosPorFila($resource) {
        var resourceUrl = 'api/chamados-por-fila';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'POST',
                isArray: true
            }

        });
    }


})();
